// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"501":"practica1","894":"practica2"}[chunkId] + "." + {"501":"3e5e29ad","894":"a3a97dcc"}[chunkId] + ".js";
};